import { Navbar2Element, NavbarDropdownMenuItem } from '@typedream/core';
import { createMachine } from 'xstate';
import {
  ToolbarNavbarDropdownColumnDropEvent,
  ToolbarNavbarDropdownMenuEmptyColumnAddEvent,
  ToolbarNavbarDropdownMenuItemDropEvent,
  ToolbarNavbarDropdownMenuItemEvent,
} from '../../../../../types';

type MenuType = 'brand' | 'menu' | 'endMenu';

type MachineContext = {
  dataNavbar?: Navbar2Element,
  menuIndex?: number,
  menuType?: MenuType,

  // Changed by column setting toolbar
  selectedDropdownItemType?: 'column' | 'column_item',
  selectedColumnItemId?: string,
  selectedColumnId?: string,
  selectedColumnIdx?: number,
  selectedColumnItemIdx?: number,
  dropdownColumnItemType?: NavbarDropdownMenuItem['itemType'],
};

export const navbarDropdownContainerFSM = createMachine({
  // eslint-disable-next-line max-len
  /** @xstate-layout N4IgpgJg5mDOIC5QDkCGA3ARqgTgERwHsAHCQgdwDsBhQygF1QEtKwcAxAZQFkA6JiABswAYgDyyAPp4ASmIAKeMQHUpCgKLIA2gAYAuolDFCsJvSZ1DIAB6IAtAGYHAJl4BGAOwBOAGzOAHAAsHt7+Pl4eADQgAJ72AKzx7p46TjqB8YE6HvFe8QC++dFoWLgEJGRUtAzMrBw8vJwAFhQABBBEpBSUrQC2YJQArq2olBCtJOZ0sOJSsgpKqpLUADJinOq6BkggxqZTlFa2CM7pvLk+fg4+bpdeTj7RcQh2bs4+ydduWS4hET6FYoYbD4TqVGh0RgsNhcPjNNodCrdPoDYajcaTCyUGYSSTcTQAVWk6hW6gAKuo8FsrHszFijvY8rwPD4QoFAj5Ug4vM5Mk8Eh5eOF4m54h4XJkchzASASiDyl0qpDajCGvDyO0wcj+kMRmMJsQDrBGi0NZhCPR6IRegajfwhKJcdQABIAQWQAHF1JJOGSAJqk6k7WkHBkvVwOHQ6cIefypPJeHS8-kIdk6XiRnwZJweVLea4yuVlLVKmrQ+pw02apFUFG69G2rHG9Wtc2W62N6b24SzSSuvB4ZZiFYE7jafQ0kx0yw7Y52dNBRKBNxue4c1f+Fwpm6Bc7OFn3WM+fweQvA4s1iFluqwk0Iks9HVo-WYrstttWm2v7Hdx1SfuDtQw6jlIACSFLcEGRhTqGs72A45weFkOheG4-huCh3ghFEsSIA4ni8ChtweO8YSBLyXhnqUoKXtUUI3mqVaIoqj6onqGKGk2jRgJaLBQK03Cor28zyEOI5jpI4HqJBE7BjB9JweGK7Mih8TXDyYTXH4KaivhzJeGEGGpFk8THlR8oPnRKoVneGrMeCdbPhxdqcDx5iUPxglDMJciiUB4njts0H7ApoBzqcSQ6EE+5xg4i7OA4gQ6Q4pnnGpHhvAZJHOAl5kXixVnlreLb2dqbENt+zZuXxAlCbiAGSMg6jKGJIGSRBUG7PJM5hYg8Q6EkXj3JuorZseOHPEZriBP4vLON8NwhD4Dh5TRBXKkVjH3pejnsZ2P6ubxHm1UMv69twYgEhskiaBSMjtdJnUhqFNh4e8vCBNy-hBKhgR5Fm8Q6aubi8Dyq7kVFwTzc4q0KuChUMZW20sbtFWcW+1XHV5gy2a0LToGwkCtoQOAQGw52XddpKugAat6UkyUFXUhT1r0IJu6amW4cX9f4Yq3G4KY8oKeTzTkor9dkBRFLK55rfDG2I7jpW1k+e2VdxR2eaiuP44T4zmqTbC8NQTRgAAxgA1jVKusbq9AxMQohPd1hyKTkHxfCK3irvEvITYgaEoRmIrRiuOiitGK0y0W8vdAjqpI3ZD6oy+6MHZj2unS2es4EThtkzgJtm1bNsp2rDtOyIWhuEzz2s8cOQIXzm5eDNubzWhOnfYNqExiezgGYlsOWYrifK+X5Vpy5mcnTjOeEATecGyThe4+bhCCIMvR2zjAg9rieAkuS3r+SBLss27vUICusa8P4v0ZGh1yYTp7wIYlf0sj4pm5rNI+0THjZEqk96zTy4oddyWd55VlzvnVexsWwby3jvVoZgwA2ifGdJ0bpPSn2AhJBmkgyTgUDLJYK04r5s25tkXgc0UrLkWokFMzhyL+AzChKMpl5oMIAeta848QE7TVmjGeWs5660XvrYmRsi5IM3tvHo6DME633n+ZYuCvStUIRBYknBqAyFAvIEhEgL6ULDNzbmQoGFRhQhEBwsYWGJCSBheaP8SIpTUv4PhCsBHAKYqApy+0qriOxpIpe8DZHrwUag5RjlsFSBdO6LRZ8dHSUkCsUCyAADSZjYLX0yl4e+0ZYwinbvuJKuETjHg+GEH+nhRQ5WCD4+OQDioBOEVPZyEDZ5hIXhEleUT5EoKUfQDB8S1G9iSXg7RYFdGZJyZIDQUgmotTJK6AAQnkl6xwaHpmyENP6QRghihYZGVwCUUj7nSNyaWQJqJw1aX49pyMHIiPARjUJOt+nSILogqsyDFFoLGSo06kycHJPwQFB63BiF+nkJschzNzGKUyoKRIrJxTXCCLNBwLDPBJACCuB+WZrhYpaaWeigiOko3ed0z5UCJE-OXjItewygVxKweCuYx8KSzJhdshugcRRCg5HFb4kNULpB0jyXcPIBocj9qZRIFKrxUv8a8sqYD6UZy+dnWBUiWV-LkQCmJozxlcodFMzRUK2pEPYBIMkgqqG7MzPfEI1weFZhIpU54RKimJjbrmDkqRciBFVQnDVydOnauCZrRlfSDUDNZf8togLYkgomVap0mTqDZMkkBKQ+JkAEmdWGTkINEwcxcFwpwvrEDzU3HQzwJEI4cwyhGtpW1o20q6XGyBNVE1tDgYMtlpqRnAotTrAkxBBCEFQBAGqTAN6UBEGQVg-BKDoEIJbMAvBBizvnRAUCvRUAwDLYpeV5wcxDU5A49kgsqm8kjBmPwK4so8jyNHe5FlAHPO7dWXtsaNYDqxt8pNvyEEmrTWaydoKcYzrnQupdK6RBsCIEXWdqB6AADMSa9H3YehdJ6z1gAvdfNu7D8IBGimpZc+EWF3A+vcQeWQ8iWNPDHOWjzKXWReT2t5faQO9PA8Ow1kSx0wYnZy0TGpl10EctayF-KiGgULeRtmJ59ncnUukDI4pnBnPCPfY5iZTLhAGp2-9SdAOCeA+nEJCbZN43E6O1NGp03mvg7jeTu9ewEnkGsfsKndFqdMUi+uLq+o3EIg-TIKVbj7jUiw4IHwTmcLUjlTwVn1X8ds1qoJwm9UwLE8m410TpOZqwS2Xzimc3rHpoWvEhINPHHY+cdkIohpRW5BkFh+4QZMKGhlPm81Cgy0oIQMm8Adixx42qvjPBJyXzDI4OM7hvB+CCH8MIEQUx2HeLuHmD9DxzXQjlxbfA1HLZRdfA731mPvD+NkZaeZ9ueFqQZZcHq31DW-bLB5o9rMTxjYVhzN38ls3uwhXwopuYsjigZZhVTviuBXJcEIPcMKJQBFxwHf7csAdtqnHVzYqwfg7JVCHOz7AJUGjcEUDjloPxbv1opnJvt+z5iyDk3i8e-v4YTmzxO6X9vJxaT8cbrtyRW4pV4J5QYM-h8zpH-gUwciKX9W433uTQzcBdzawvAnqwc-GwdqJqdCoQBEUG1wZoGUHt8BLKYgjpg5ByepbDlqcZ-flXxQuQdAbB2IpzYKHSW6izfDItusws8d59QGVS8icwG59NCGK+YG6VkIoPJuQ-m-1aVyDsiI9hkVbFvICfEtNx0iKCMt83geJ5Fn6lmrVZCdN6B6B4Ti9r1Nhba2x0RdsUrmAUvikRQfDUm8SMOmWTc1r0NfSPJMiHYPHz33cdeOG8D3Z4PPTis96NVBirQKnzj4KakdhPDuQRwcVFZHk1ORFPiOheaoaQimRb1G-L7f7P57A0Lw1BHRTWgw81g0tWEAv2oSig+Bv0THhwf0Tyfxt2jBPBFBZ05C-35z9yeQDxzz3zzwP1DxK2ANc1ANPwzSnSGGgOOEZwr3i0nySzxRR263cFZEuGWmIm5m-zy2H3-2IIL1IJczKxP3ZSoO82lwoUh12VFGvzQixT5giBmhYWyEFB-l5jjBmmCAiF4KJ2N1EUEMAOEJAPK3EK83iUQyPRQ1ZkizDDFCO3FDUnCDhxXEMyfUyAXESijDpzh15D0KN1ByIIZSEKPwk3c1aE8zg3iRqxXUcloMQBuBh1sTmgGgGlZDZ0+zeDUlDnSBZHG3yCAA */
  id: 'NavbarDropdownContainerFSM',
  tsTypes: {} as import('./NavbarDropdownContainer.fsm.typegen').Typegen0,
  initial: 'idle',
  states: {
    idle: {
      on: {
        ON_DROPDOWN_OPEN: {
          target: 'Show dropdown menu and options',
          actions: 'assignNavbarToContext',
        },
      },
    },

    'Show dropdown menu and options': {
      states: {
        'Show bottom options': {
          tags: ['ui:show_bottom_options'],

          states: {
            idle: {
              on: {
                ON_CHANGE_STYLE: {
                  target: 'idle',
                  description: 'The style of the dropdown container has changed. The possible value is `card` or `big-box`',
                  actions: ['assignStyleToContext', 'effectUpdateSlateNode'],
                  internal: true,
                },

                ON_ADD_COLUMN: {
                  target: 'idle',
                  internal: true,
                  actions: ['assignNewColumnToContext', 'effectUpdateSlateNode'],
                },

                ON_ADD_COLUMN_ITEM: {
                  target: 'idle',
                  internal: true,
                  actions: ['assignNewColumnItemToContext', 'effectUpdateSlateNode'],
                },
              },
            },
          },

          initial: 'idle',
        },

        'Setting Menu': {
          states: {
            idle: {
              on: {
                ON_MOUSE_ENTER_ITEM: {
                  target: 'Show hovered border',
                  actions: 'assignSelectedColumnToContext',
                },
              },
            },

            'Show hovered border': {
              tags: ['ui:show_hovered_border'],

              on: {
                ON_MOUSE_LEAVE_ITEM: {
                  target: 'idle',
                  actions: 'assignSelectedColumnToContext',
                },
              },

              states: {
                'Checking dropdown menu type': {
                  description: 'Transition state that check if the dropdown menu is a column or a column item',
                  always: [{
                    target: 'Show column menu',
                    cond: 'isColumn',
                  }, 'Show column item menu'],
                },

                'Show column menu': {
                  states: {
                    idle: {
                      on: {
                        ON_DELETE_COLUMN: {
                          target: '#NavbarDropdownContainerFSM.Show dropdown menu and options.Setting Menu.idle',
                          actions: ['assignNewColumnToContext', 'effectUpdateSlateNode'],
                        },
                      },
                    },
                  },

                  initial: 'idle',
                },

                'Show column item menu': {
                  states: {
                    idle: {
                      on: {
                        ON_CHANGE_COLUMN_ITEM_TITLE: {
                          target: 'idle',
                          internal: true,
                          actions: ['assignColumnItemTitleToContext', 'effectUpdateSlateNode'],
                        },

                        ON_CHANGE_COLUMN_ITEM_DESCRIPTION: {
                          target: 'idle',
                          internal: true,
                          actions: ['assignColumnItemDescriptionToContext', 'effectUpdateSlateNode'],
                        },

                        ON_CHANGE_COLUMN_ITEM_LINK: {
                          target: 'idle',
                          internal: true,
                          actions: ['assignColumnItemLinkToContext', 'effectUpdateSlateNode'],
                        },

                        ON_CHANGE_COLUMN_ITEM_LINK_OPEN_NEW_TAB: {
                          target: 'idle',
                          internal: true,
                          actions: ['assignColumnItemLinkToContext', 'effectUpdateSlateNode'],
                        },

                        ON_CHANGE_COLUMN_ITEM_TYPE: {
                          target: '#NavbarDropdownContainerFSM.Show dropdown menu and options.Setting Menu.idle',
                          actions: ['assignColumnItemTypeToContext', 'effectUpdateSlateNode'],
                        },

                        ON_DELETE_COLUMN_ITEM: {
                          target: '#NavbarDropdownContainerFSM.Show dropdown menu and options.Setting Menu.idle',
                          actions: [
                            'assignNewColumnItemToContext',
                            'effectUpdateSlateNode',
                            'assignSelectedColumnToContext',
                          ],
                        },

                        ON_CHANGE_COLUMN_ITEM_FONT: {
                          target: 'idle',
                          internal: true,
                          actions: ['assignColumnItemFontToContext', 'effectUpdateSlateNode'],
                        },

                        ON_CLICK_ICON_MENU: 'Show icon menu',
                      },
                    },

                    'Uploading icon': {
                      tags: ['ui:show_icon_menu'],
                      invoke: {
                        src: 'uploadImage',
                        id: 'uploadImage',
                        onDone: {
                          target: 'idle',
                          actions: ['assignColumnItemIconToContext', 'effectUpdateSlateNode'],
                        },
                        onError: 'idle',
                      },
                    },

                    'Show icon menu': {
                      tags: ['ui:show_icon_menu'],
                      on: {
                        ON_CHANGE_COLUMN_ITEM_ICON: {
                          target: 'idle',
                          actions: ['assignColumnItemIconToContext', 'effectUpdateSlateNode'],
                        },

                        ON_UPLOAD_COLUMN_ITEM_ICON: 'Uploading icon',
                        ON_CLOSE_ICON_MENU: 'idle',
                      },
                    },
                  },

                  initial: 'idle',
                },
              },

              initial: 'Checking dropdown menu type',
            },
          },

          initial: 'idle',

          on: {
            ON_DROP_COLUMN_ITEM: {
              target: 'Setting Menu',
              internal: true,
              actions: ['assignDroppedColumnItemToContext', 'effectUpdateSlateNode'],
            },

            ON_DROP_COLUMN: {
              target: 'Setting Menu',
              internal: true,
              actions: ['assignDroppedColumnToContext', 'effectUpdateSlateNode'],
            },

            ON_ADD_NEW_COLUMN_ITEM: {
              description: 'Add a new column item from empty column or column placeholder',
              target: '.idle',
              actions: ['assignNewColumnToContext', 'effectUpdateSlateNode'],
            },
          },
        },
      },

      type: 'parallel',

      on: {
        ON_DROPDOWN_CLOSE: {
          target: 'idle',
          actions: 'assignNavbarToContext',
        },
        ON_MENU_DELETED: {
          target: 'idle',
          description: 'When the referenced menu is deleted, close this overlay menu.',
        },
      },
    },
  },
  schema: {
    context: {} as MachineContext,
    events: {} as
      | { type: 'ON_CHANGE_STYLE'; style: 'card' | 'big-box' }
      | { type: 'ON_ADD_COLUMN' }
      | { type: 'ON_ADD_COLUMN_ITEM' }
      | {
        type: 'ON_SELECT_COLUMN',
        columnIndex: number,
        menuType: MenuType,
        menuINdex: number,
      }
      | {
        type: 'ON_MOUSE_ENTER_ITEM',
        payload: ToolbarNavbarDropdownMenuItemEvent
      }
      | {
        type: 'ON_MOUSE_LEAVE_ITEM',
        payload: ToolbarNavbarDropdownMenuItemEvent
      }
      | {
        type: 'ON_DESELECT_COLUMN',
      }
      | {
        type: 'ON_DROPDOWN_OPEN',
        dataNavbar: Navbar2Element,
        menuIndex: number,
        menuType: MenuType
      }
      | { type: 'ON_DROPDOWN_CLOSE' }
      | { type: 'ON_CHANGE_COLUMN_ITEM_TITLE', payload: ({ newTitle: string } | { newColor: string }) }
      | { type: 'ON_CHANGE_COLUMN_ITEM_DESCRIPTION', payload: ({ newDescription: string } | { newColor: string }) }
      | {
        type: 'ON_CHANGE_COLUMN_ITEM_LINK', payload: {
          url: string,
          pageID?: string,
          pagePath?: string,
        }
      }
      | { type: 'ON_ADD_NEW_COLUMN_ITEM', payload: ToolbarNavbarDropdownMenuEmptyColumnAddEvent }
      | { type: 'ON_CHANGE_COLUMN_ITEM_LINK_OPEN_NEW_TAB', payload: { openNewTab: boolean } }
      | { type: 'ON_CHANGE_COLUMN_ITEM_ICON', payload: { icon: string } }
      | { type: 'ON_CHANGE_COLUMN_ITEM_TYPE', payload: { type: NavbarDropdownMenuItem['itemType'] } }
      | { type: 'ON_CHANGE_COLUMN_ITEM_FONT', payload: { font: NavbarDropdownMenuItem['fontFamily'] } }
      | { type: 'ON_DROP_COLUMN_ITEM', payload: ToolbarNavbarDropdownMenuItemDropEvent }
      | { type: 'ON_DROP_COLUMN', payload: ToolbarNavbarDropdownColumnDropEvent }
      | { type: 'ON_DELETE_COLUMN' }
      | { type: 'ON_DELETE_COLUMN_ITEM' }
      | { type: 'ON_CLICK_ICON_MENU' }
      | { type: 'ON_CLOSE_ICON_MENU' }
      | { type: 'ON_UPLOAD_COLUMN_ITEM_ICON', newFile: File }
      | { type: 'ON_MENU_DELETED' },
  },
});
